module.exports = __webpack_public_path__ + "img/01.179ccd6e.jpg";